import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import * as selector from '../../selectors/selectors'
import { UserService } from '../../services/UserService'
import { AppRoutes } from '../routes/route.path'
import BlockedContactsComponent from './blocked-contacts.component'
import GeneralComponent from './general.component'
import LowCreditNotification from './low-credit-notification.component'
import NotificationSettings from './notification-settings-component'
import ScheduledReport from './scheduled-report.component'
import SettingsMenu from './settings.menu.component'
import Signature from './signature.component'
import UnsubscribedContacts from './unsubscribe.component'
import AfterHours from './after-hours.component'
import ComplianceMessage from './complianceMsg.component'
import FeatureFlag from './featureFlag.component'
import APIACCESSCOMPONENT from './api-access.component'


const SettingsRouteComponent = () => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [activeMenu, setActiveMenu] = useState<string>(IsMobileDevice ? AppRoutes.SETTINGS : AppRoutes.GENERAL);
    const [hideMenu, setHideMenu] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!IsMobileDevice && location.pathname === AppRoutes.SETTINGS) {
            navigate(AppRoutes.GENERAL, { replace: true });
        } else {
            setActiveMenu(location.pathname);
        }
        setHideMenu(IsMobileDevice || UserService.hasSysAdminRole())
    }, [location.pathname])

    const renderContent = () => {
        switch (activeMenu) {
            case AppRoutes.GENERAL:
                return <GeneralComponent />;
            case AppRoutes.NOTIFICATION_SETTINGS:
                return <NotificationSettings />;
            case AppRoutes.BLOCKED:
                return <BlockedContactsComponent IsLoading={false} />;
            case AppRoutes.UNSUBSCRIBE:
                return <UnsubscribedContacts />;
            case AppRoutes.SIGNATURE:
                return <Signature />;
            case AppRoutes.LOW_CREDIT_NOTIFICATION:
                return <LowCreditNotification />;
            case AppRoutes.SCHEDULED_REPORT:
                return <ScheduledReport onClose={function (isConfim: boolean): void {
                    throw new Error('Function not implemented.')
                }} Options={[]} />;
            case AppRoutes.AFTER_HOURS:
                return <AfterHours />;
            case AppRoutes.COMPLIANCE_MESSAGE:
                return <ComplianceMessage />;
            case AppRoutes.FEATURE_FLAG:
                return <FeatureFlag />;
            case AppRoutes.API_ACCESS:
                return <APIACCESSCOMPONENT />
            default:
                return (
                    UserService.hasSysAdminRole() ? <GeneralComponent /> : (IsMobileDevice ? <SettingsMenu slectedMenu={activeMenu} /> : <GeneralComponent />)
                );
        }
    };

    return (
        <div className={`${IsMobileDevice ? "" : "br-2 m-auto settings-container"} bg-color-primary-background`}>
            <div className={`${IsMobileDevice ? "" : "d-flex  br-2 inner-settings-container bg-color-primary-background"} h-p-95`}>
                {!hideMenu &&
                    <SettingsMenu slectedMenu={activeMenu} />
                }
                <div className={`${IsMobileDevice ? "flex-1" : "flex-1 mx-4"} h-p-100 bg-color-primary-background o-y-scroll`}>
                    {renderContent()}
                </div>
            </div>
        </div>

    )
}

export default SettingsRouteComponent